/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RegisteredUser } from './RegisteredUser';
import {
    RegisteredUserFromJSON,
    RegisteredUserFromJSONTyped,
    RegisteredUserToJSON,
    RegisteredUserToJSONTyped,
} from './RegisteredUser';

/**
 * 
 * @export
 * @interface GetRegisteredUsersResponse
 */
export interface GetRegisteredUsersResponse {
    /**
     * 
     * @type {Array<RegisteredUser>}
     * @memberof GetRegisteredUsersResponse
     */
    items: Array<RegisteredUser>;
    /**
     * 
     * @type {boolean}
     * @memberof GetRegisteredUsersResponse
     */
    nextPage: boolean;
}

/**
 * Check if a given object implements the GetRegisteredUsersResponse interface.
 */
export function instanceOfGetRegisteredUsersResponse(value: object): value is GetRegisteredUsersResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('nextPage' in value) || value['nextPage'] === undefined) return false;
    return true;
}

export function GetRegisteredUsersResponseFromJSON(json: any): GetRegisteredUsersResponse {
    return GetRegisteredUsersResponseFromJSONTyped(json, false);
}

export function GetRegisteredUsersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRegisteredUsersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(RegisteredUserFromJSON)),
        'nextPage': json['nextPage'],
    };
}

export function GetRegisteredUsersResponseToJSON(json: any): GetRegisteredUsersResponse {
    return GetRegisteredUsersResponseToJSONTyped(json, false);
}

export function GetRegisteredUsersResponseToJSONTyped(value?: GetRegisteredUsersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(RegisteredUserToJSON)),
        'nextPage': value['nextPage'],
    };
}

